var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"digitboard p-2 px-3"},[_c('span',{staticClass:"digit-title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('span',{staticClass:"digit-value"},[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm.value ? _vm.value : 0))])])
}
var staticRenderFns = []

export { render, staticRenderFns }